import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
    name: "cart",
    initialState: {
        cartItems: [],
    },
    reducers: {
        setCartItems: (state, action) => {
            state.cartItems = action.payload;
        },
        addToCart: (state, action) => {
            const itemIndex = state.cartItems.findIndex(item => item.productId === action.payload.productId);
            if (itemIndex >= 0) {
                // Update quantity if item exists
                state.cartItems[itemIndex].quantity += action.payload.quantity;
            } else {
                // Add new item
                state.cartItems.push(action.payload);
            }
        },
        clearCart: (state) => {
            state.cartItems = [];
        },
    },
});

export const { setCartItems, addToCart, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
